import React, { useEffect, useState } from 'react';
import './HowTo.css';
import { fetchData } from '../../config/dataService';

function Section({ section }) {
  switch (section.type) {
    case 'steps':
      return (
        <div className="howto__section">
          <h2 className="howto__section-title">{section.title}</h2>
          <div className="howto__steps">
            {section.items.map((step, i) => (
              <div key={i} className="howto__step fade-up" style={{ animationDelay: `${i * 0.08}s` }}>
                <div className="howto__step-number">{String(i + 1).padStart(2, '0')}</div>
                <div className="howto__step-content">
                  <h3 className="howto__step-title">{step.title}</h3>
                  <p className="howto__step-body">{step.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      );

    case 'info':
      return (
        <div className="howto__section">
          <h2 className="howto__section-title">{section.title}</h2>
          <div className="howto__info-grid">
            {section.items.map((box, i) => (
              <div key={i} className="howto__info-box">
                <h4>{box.title}</h4>
                <p>{box.body}</p>
              </div>
            ))}
          </div>
        </div>
      );

    case 'list':
      return (
        <div className="howto__section">
          <h2 className="howto__section-title">{section.title}</h2>
          <div className="howto__list">
            {section.items.map((item, i) => (
              <div key={i} className="howto__list-item">{item}</div>
            ))}
          </div>
        </div>
      );

    default:
      return null;
  }
}

export default function HowTo() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetchData('howto')
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-state">Loading guide…</div>;
  if (error)   return <div className="error-state">Could not load guide. Please try again.</div>;

  const { title = 'How It Works', subtitle, sections = [] } = data || {};

  return (
    <main className="howto">
      <div className="container">
        <div className="howto__header">
          <h1 className="section-title">{title}</h1>
          {subtitle && <p className="section-subtitle">{subtitle}</p>}
          <div className="divider" />
        </div>
        <div className="howto__sections">
          {sections.map((section, i) => (
            <Section key={i} section={section} />
          ))}
        </div>
      </div>
    </main>
  );
}
